"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var ButtonGroup = function (props) {
    var children = props.children;
    return React.createElement(StyledGroup, null, children);
};
exports.default = ButtonGroup;
var StyledGroup = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    > button:not(:first-of-type) {\n      margin-left: 0.8rem;\n    }\n  }\n"], ["\n  && {\n    > button:not(:first-of-type) {\n      margin-left: 0.8rem;\n    }\n  }\n"])));
var templateObject_1;
